import { DocumentNode, gql } from '@apollo/client'
import { assignSubComponents } from '@farol-ds/react/utilities/internal'
import { forwardRef } from 'react'

import { ChooseFrequencyLaterSelectFrequencyStep } from './choose-frequency-later-select-frequency-step'
import { ChooseFrequencyLaterSelectOfferStep } from './choose-frequency-later-select-offer-step'

type ChooseFrequencyLaterStepElement = HTMLDivElement

interface ChooseFrequencyLaterStepProps {
  children: React.ReactNode
}

const ChooseFrequencyLaterStepRoot = forwardRef<
  ChooseFrequencyLaterStepElement,
  ChooseFrequencyLaterStepProps
>(function ChooseFrequencyLaterStep(props) {
  const { children } = props

  return children
})

const ChooseFrequencyLaterStepWithRef = assignSubComponents(
  'ChooseFrequencyLaterStep',
  ChooseFrequencyLaterStepRoot,
  {
    SelectOffer: ChooseFrequencyLaterSelectOfferStep,
    SelectFrequency: ChooseFrequencyLaterSelectFrequencyStep,
  }
)

type ChooseFrequencyLaterStepWithRefType = typeof ChooseFrequencyLaterStepWithRef
interface ChooseFrequencyLaterStepWithFragments extends ChooseFrequencyLaterStepWithRefType {
  fragments: Record<string, DocumentNode>
}

export const ChooseFrequencyLaterStep: ChooseFrequencyLaterStepWithFragments = Object.assign<
  ChooseFrequencyLaterStepWithRefType,
  Pick<ChooseFrequencyLaterStepWithFragments, 'fragments'>
>(ChooseFrequencyLaterStepWithRef, {
  fragments: {
    offerLockData: gql`
      fragment ChooseFrequencyLaterStep_offerLockData on OfferLockData {
        ...ChooseFrequencyLaterSelectOfferStep_offerLockData
        ...ChooseFrequencyLaterSelectFrequencyStep_offerLockData
      }
      ${ChooseFrequencyLaterSelectOfferStep.fragments.offerLockData}
      ${ChooseFrequencyLaterSelectFrequencyStep.fragments.offerLockData}
    `,
    viewer: gql`
      fragment ChooseFrequencyLaterStep_viewer on Profile {
        ...ChooseFrequencyLaterSelectFrequencyStep_viewer
      }
      ${ChooseFrequencyLaterSelectFrequencyStep.fragments.viewer}
    `,
  },
})
